import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, confirmed, is_not, min_value } from 'vee-validate/dist/rules';
import { phone } from 'phone';


extend('required', {
  ...required,
  message: 'This field is required'
});
extend('min_value', min_value);
extend('email', email);
extend('confirmed', confirmed);
extend('min', {
  validate(value, { length }) {
    return value.length >= length;
  },
  params: ['length'],
  message: 'The {_field_} field must have at least {length} characters'
});
extend('is_not', is_not);
extend('ph-mobile', {
  message: 'Invalid format',
  validate(value){
    var result = phone(value, { country: 'PHL', strictDetection: false });
    return result.isValid;
  }
});


  
// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);